import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-skip-forward-icon',
  templateUrl: './bmcore-skip-forward-icon.component.html',
  styleUrls: ['./bmcore-skip-forward-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreSkipForwardIconComponent {
  @Input() fillColor = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
